// Producatori carousel on mobile — works on any page where brand logos appear
(function(){
  function wrapGridWithCarousel(grid) {
    if (!grid || grid.closest('.producatori-carousel-wrap')) return;  // already wrapped

    var wrap = document.createElement('div');
    wrap.className = 'producatori-carousel-wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'producatori-arrow prev';
    prev.setAttribute('aria-label', 'Anterior');
    prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'producatori-arrow next';
    next.setAttribute('aria-label', 'Urmator');
    next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    wrap.appendChild(prev);
    wrap.appendChild(next);

    function scrollBy(dir) {
      var cards = grid.children;
      if (!cards.length) return;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var gap = 12;
      grid.scrollBy({ left: dir * (cardWidth + gap) * 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', function(){ scrollBy(-1); });
    next.addEventListener('click', function(){ scrollBy(1); });

    function updateArrows() {
      var show = window.innerWidth <= 768;
      prev.style.display = show ? 'flex' : 'none';
      next.style.display = show ? 'flex' : 'none';
    }
    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  function init() {
    // /pages/producatori page
    document.querySelectorAll('.producatori-grid').forEach(wrapGridWithCarousel);
    // Homepage and other pages with injected brand section
    document.querySelectorAll('.producers-grid').forEach(wrapGridWithCarousel);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after dynamic injection (homepage inserts brands via JS)
  // Use MutationObserver to catch late injections
  var observer = new MutationObserver(function(){
    var grids = document.querySelectorAll('.producatori-grid:not([data-carousel-init]), .producers-grid:not([data-carousel-init])');
    grids.forEach(function(g){ g.setAttribute('data-carousel-init', '1'); wrapGridWithCarousel(g); });
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    window.addEventListener('DOMContentLoaded', function(){
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
